<template>
    <div class="test-shell">
        <div class="coupon-tab-list">
            <div class="coupon-tab-box" :class="{'coupon-tab-box-active': item.code==tab_code}"
                 v-for="(item,index) in tab_list" :key="index" @click.stop="cut_tab(item,index)">
                {{item.name}}
            </div>
        </div>
        <div class="test-content">
            <div class="test-list" v-show="tab_code==1">
                <div class="test-box" v-for="(item,index) in simulate_list"
                     @click="$router.push('/test?qst_id='+item.qst_id)" :key="index">
                    <div class="test-icon">
                        <img src="@/assets/amd.png" alt=""/>
                    </div>
                    <div class="test-info">
                        <div class="test-name">{{item.qst_name}}</div>
                        <div class="test-type">类别：{{item.cate_name}}</div>
                    </div>
                </div>
                <NoData v-if="simulate_list.length<1" width="168px" height="235px"></NoData>
                <div class="paging-shell" v-if="cnt_data>10">
                  <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-size="page_size"
                    background layout="prev, pager, next" :total="cnt_data"></el-pagination>
                </div>
            </div>
            <div class="err-test" v-show="tab_code==2">
                <div class="err-num-shell">
                    <div class="err-num">错题数：{{error_num}}</div>
                    <div class="err-test-btn" @click.stop="$router.push('/simulativeTset?error_type=1')">巩固错题</div>
                </div>
                <div class="test-type-shell">
                    <div class="type-title">
                        巩固错题
                    </div>
                    <div class="list" v-for="(item,index) in error_info" :key="index"
                         @click.stop="$router.push('/test?error_type=1&qst_id='+item.qst_id)">
                        <div class="exercise">
                            <span>{{item.qst_name}}</span>
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="err-test" v-if="tab_code==3">
                <test-list :show="false"></test-list>
            </div>

        </div>
    </div>
</template>

<script>
  import NoData from '@/components/no-data.vue'
  import testList from '@/views/home/Golearn/simulativeTset/index'

  export default {
    name: 'test',
    components: {
      NoData,
	  testList
    },
    data () {
      return {
        simulate_list: [],
        tab_list: [
          {
            name: '模拟练习',
            code: 3
          },
          {
            name: '已购课程试题',
            code: 1
          },
          {
            name: '错题集',
            code: 2
          },
        ],
        tab_code: 3,
        simulate_cate: [],
        error_info: {},
        error_num: 0,
        pageIndex: 1,
        page_size: 10,
        cnt_data: 0,
      }
    },
    mounted () {
      if(this.$route.query.tab_code){
        this.tab_code = this.$route.query.tab_code
      }
      this.get_simulate_list()
      this.get_simulate_cate()
      this.get_error_info()
    },
    methods: {
      get_error_info () { // 错题集
        this.API.post('user/question_in-get_mistakes_qst', {}).then((res) => {
          this.error_info = res.data.data
          this.error_num = 0
          for (let i = 0; i < this.error_info.length; i++) {
            this.error_num += this.error_info[i].cnt
          }
        })
      },
      cut_tab (item) {
        this.tab_code = item.code
      },
      get_simulate_list () { // 模拟试题
        this.API.post('user/question_in-order_list', {
          page: this.pageIndex,
          page_size: this.page_size,
        }).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.simulate_list = res.data.order_list
          this.cnt_data = res.data.cnt_data
        })
      },
      handleCurrentChange (value) {
        this.pageIndex = value
        this.get_simulate_list()
      },
      get_simulate_cate () {
        this.API.post('Home/question_out-get_question_cate', {}).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.simulate_cate = res.data.cate_list
        })
      },
    }
  }
</script>

<style lang="less" scoped>
    .coupon-tab-list {
        display: flex;
        align-items: center;
        height: 76px;
        border-bottom: 1px solid #DCDCDC;
        width: 958px;
        padding: 0 40px;

        .coupon-tab-box {
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 72px;
            height: 100%;
            font-size: 22px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #666666;
            margin-left: 47px;
            cursor: pointer;
        }

        .coupon-tab-box-active {
            color: #2AA9B5;
            position: relative;

            &:after {
                position: absolute;
                bottom: 0px;
                left: 50%;
                transform: translateX(-50%);
                content: "";
                width: 110%;
                height: 5px;
                background: #2AA9B5;
                border-radius: 3px;
            }
        }
    }

    .test-content {
        .test-list {
            padding: 20px 19px;
            overflow-y: auto;
            max-height: 800px;
            .test-box {
                display: flex;
                align-items: center;
                width: 918px;
                min-height: 116px;
                background: #FFFFFF;
                border: 1px solid #E5E5E5;
                margin-bottom: 16px;
                padding: 10px 33px;
                cursor: pointer;

                .test-icon {
                    margin-right: 22px;

                    img {
                        width: 39px;
                        min-width: 39px;
                        height: 35px;
                    }
                }

                .test-name {
                    font-size: 18px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #000000;
                    margin-bottom: 15px;
                }

                .test-type {
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #999999;
                }
            }
        }
    }

    .err-num-shell {
        display: flex;
        align-items: center;
        margin: 27px auto 0;
        width: 911px;
        height: 124px;
        background: #FFFFFF;
        border: 1px solid #E5E5E5;

        .err-num {
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #FF0000;
            margin: 0 32px 0 28px;
        }

        .err-test-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 104px;
            height: 43px;
            background: #FFFFFF;
            border: 1px solid #BFBFBF;
            cursor: pointer;
        }
    }

    .test-type-shell {
        .type-title {
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #000000;
            padding: 34px 32px;
        }
        .list{
            .exercise{
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 911px;
                height: 80px;
                margin: 0 auto 16px;
                padding: 0 23px;
                background: #FFFFFF;
                border: 1px solid #E5E5E5;
                font-size: 22px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #666666;
            }
        }
    }
</style>
